// Constants for total of all receipts
export const RECEIPT_SPEND_REQUEST = 'RECEIPT_SPEND_REQUEST'
export const RECEIPT_SPEND_SUCCESS = 'RECEIPT_SPEND_SUCCESS'
export const RECEIPT_SPEND_FAILURE = 'RECEIPT_SPEND_FAILURE'
export const RECEIPT_SPEND_RESET = 'RECEIPT_SPEND_RESET'

// Individual Receipt Constants for daily spend
export const META_RECEIPT_SPEND_REQUEST = 'META_RECEIPT_SPEND_REQUEST'
export const META_RECEIPT_SPEND_SUCCESS = 'META_RECEIPT_SPEND_SUCCESS'
export const META_RECEIPT_SPEND_FAILURE = 'META_RECEIPT_SPEND_FAILURE'
export const META_RECEIPT_SPEND_RESET = 'META_RECEIPT_SPEND_RESET'

// Constants for total receipts per owner
export const OWNER_DAILY_COUNT_REQUEST = 'OWNER_DAILY_COUNT_REQUEST'
export const OWNER_DAILY_COUNT_SUCCESS = 'OWNER_DAILY_COUNT_SUCCESS'
export const OWNER_DAILY_COUNT_FAIL = 'OWNER_DAILY_COUNT_FAIL'
export const OWNER_DAILY_COUNT_RESET = 'OWNER_DAILY_COUNT_RESET'

// Constants for owner metadata average ticket
export const OWNER_AVG_TICKET_REQUEST = 'OWNER_AVG_TICKET_REQUEST'
export const OWNER_AVG_TICKET_SUCCESS = 'OWNER_AVG_TICKET_SUCCESS'
export const OWNER_AVG_TICKET_FAIL = 'OWNER_AVG_TICKET_FAIL'
export const OWNER_AVG_TICKET_RESET = 'OWNER_AVG_TICKET_RESET'
